/**
 * Zuordnung welche Seite welche Properties anzeigt
 */
// Felder im HB2 die noch kein Feld im neuen Formular haben

/*
    { key: 'SEITE': [
        { key: 'FELD1' | fields: [validations] },
        { key: 'FELD2' | fields: [validations] },
]
*/

export type PubTypeGroups =
  'audio-video-object'
  | 'integrating-resource'
  | 'fragment'
  | 'self-contained'
  | 'self-contained-or-fragment'
  | 'multi-volume-work'
  | 'series'
  | 'periodical'
  | 'research-data-group'
  | 'patent'
  | 'thesis';

export const validationWorkEntityMapping: { [key: string]: PubTypeGroups } = {
  audio_video_document: 'audio-video-object',
  radio_tv: 'audio-video-object',
  blog: 'integrating-resource',
  website: 'integrating-resource',
  chapter: 'fragment',
  chapter_in_conference: 'fragment',
  chapter_in_legal_commentary: 'fragment',
  article_newspaper: 'fragment',
  article_journal: 'fragment',
  article_integrating_resource: 'fragment',
  lexicon_article: 'fragment',
  editorial: 'fragment',
  article_overview: 'fragment',
  review: 'fragment',
  abstract: 'fragment',
  monograph: 'self-contained',
  collection: 'self-contained',
  edition: 'self-contained',
  conference: 'self-contained',
  legal_commentary: 'self-contained',
  special_issue: 'self-contained',
  report_collection: 'self-contained',
  report_grey_literature: 'self-contained-or-fragment',
  interview: 'self-contained-or-fragment',
  lecture: 'self-contained-or-fragment',
  poster: 'self-contained-or-fragment',
  multi_volume_work: 'multi-volume-work',
  monograph_mvw: 'multi-volume-work',
  collection_mvw: 'multi-volume-work',
  edition_mvw: 'multi-volume-work',
  conference_mvw: 'multi-volume-work',
  series: 'series',
  newspaper: 'periodical',
  journal: 'periodical',
  research_data: 'research-data-group',
  patent: 'patent',
  student_thesis: 'thesis',
  dissertation: 'thesis',
  habilitation: 'thesis',
};
